import React from "react";
import Page from "../../../common/components/Page";
import useRecoverPassword from "./useRecoverPassword";
import RecoverPasswordForm from "./RecoverPasswordForm";
import ResetPasswordForm from "./ResetPasswordForm";

const RecoverPassword = () => {
  const { recoverPasswordForm, resetPasswordForm, recoverPasswordLoading, resetPasswordLoading, recoveryQuestion, isValidated, handleRecoverClick, handleResetClick, handleOnCancelClick } =
    useRecoverPassword();

  return (
    <Page>
      <Page.Title icon="user" title="Password Reset/Recovery" />
      <Page.Content>
        {isValidated ? (
          <ResetPasswordForm
            resetPasswordForm={resetPasswordForm}
            resetPasswordLoading={resetPasswordLoading}
            recoveryQuestion={recoveryQuestion}
            handleResetClick={handleResetClick}
            handleOnCancelClick={handleOnCancelClick}
          />
        ) : (
          <RecoverPasswordForm
            recoverPasswordForm={recoverPasswordForm}
            recoverPasswordLoading={recoverPasswordLoading}
            handleRecoverClick={handleRecoverClick}
            handleOnCancelClick={handleOnCancelClick}
          />
        )}
      </Page.Content>
    </Page>
  );
};

export default RecoverPassword;
